module.exports = __webpack_public_path__ + "img/swayvisa-logo-dark.6636d651.svg";